import React from "react";

const PREMIUM_CODE_OUTLINE =
  "inline-flex w-fit items-center justify-center rounded-lg border px-1.5 py-0.5 leading-none";

export default function PremiumCodeLabel({
  code,
  isPremium = false,
  className = "",
  outlineClassName = "",
  outlineColorClassName = "border-white",
  as: Component = "span",
  style,
}) {
  return (
    <Component
      style={style}
      className={`${
        isPremium
          ? `${PREMIUM_CODE_OUTLINE} ${outlineColorClassName} ${outlineClassName}`
          : ""
      } ${className}`.trim()}
    >
      {code}
    </Component>
  );
}
